import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LinkedSurvey } from '../../channels.model';

@Component({
  selector: 'app-channel-surveys-tab',
  standalone: false,
  templateUrl: './channel-surveys-tab.component.html',
  styleUrl: './channel-surveys-tab.component.scss'
})
export class ChannelSurveysTabComponent {
  @Input() linkedSurveys: LinkedSurvey[] = [];
  @Input() availableSurveys: LinkedSurvey[] = [];
  @Output() linkedSurveysChange = new EventEmitter<LinkedSurvey[]>();

  showSurveyPicker = false;

  get unlinkedAvailableSurveys(): LinkedSurvey[] {
    return this.availableSurveys.filter(a => !this.linkedSurveys.find(l => l.id === a.id));
  }

  linkSurvey(survey: LinkedSurvey): void {
    if (!this.linkedSurveys.find(s => s.id === survey.id)) {
      this.linkedSurveysChange.emit([...this.linkedSurveys, survey]);
    }
    this.showSurveyPicker = false;
  }

  unlinkSurvey(id: string): void {
    this.linkedSurveysChange.emit(this.linkedSurveys.filter(s => s.id !== id));
  }

  getSurveyTriggerLabel(trigger: string): string {
    const map: Record<string, string> = {
      ON_CREATION: 'ON CREATION',
      SCHEDULED: 'SCHEDULED',
      ON_UPDATE: 'ON UPDATE'
    };
    return map[trigger] ?? trigger;
  }

  getSurveyTriggerClass(trigger: string): string {
    const map: Record<string, string> = {
      ON_CREATION: 'trigger-creation',
      SCHEDULED: 'trigger-scheduled',
      ON_UPDATE: 'trigger-update'
    };
    return map[trigger] ?? '';
  }
}
